import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import { ArtifactProps, ColorProps } from "@/types";
import { selectionStore, timStore } from "@/hooks";
import ArtifactNameDisplay from "./ArtifactNameDisplay.vue";
import ArtifactBodyDisplay from "./ArtifactBodyDisplay.vue";


/**
 * Displays a chip for an artifact, which can be clicked to view the artifact in a popout.
 */
const __default__ = {
  name: "ArtifactChip",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    artifact: {},
    color: {}
  },
  setup(__props: any) {

const props = __props;

const color = computed(
  () => props.color || timStore.getTypeColor(props.artifact.type, true)
);

return (_ctx: any,_cache: any) => {
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_chip = _resolveComponent("q-chip")!

  return (_openBlock(), _createBlock(_component_q_chip, {
    color: color.value,
    icon: _unref(timStore).getTypeIcon(props.artifact.type),
    outline: "",
    style: {"max-width":"300px","height":"fit-content"},
    clickable: ""
  }, {
    default: _withCtx(() => [
      _createVNode(ArtifactNameDisplay, {
        artifact: props.artifact
      }, null, 8, ["artifact"]),
      _createVNode(_component_q_popup_proxy, null, {
        default: _withCtx(() => [
          _createVNode(ArtifactBodyDisplay, {
            clickable: "",
            "display-title": "",
            artifact: props.artifact,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(selectionStore).selectArtifact(props.artifact.id)))
          }, null, 8, ["artifact"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["color", "icon"]))
}
}

})